import axios from "axios";
const jsonConfig = require("../../Config.json");

const updateCandidateResumeById = async (id, payload) => {
    try {
        // Send the data as query parameters
        const url = `${jsonConfig.apiUrl}candidateResume${id ? `?Id=${id}` : ''}`;
        
        const response = await axios.put(
            url,
            payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );

        const apiResponse = response;

        return Promise.resolve(apiResponse);
    } catch (error) {
        return Promise.reject(error);
    }
};
export default updateCandidateResumeById;